export const DOC_PAGE_LIMIT = 25;
export const PAGE_LIMIT = 25;

export const PROJ_LIST_LIMIT = 5;
export const URL_REGEX = new RegExp('^(http|https)://', 'i');

export const SEGMENT_KEY = 'GUtny0KrzoHaJkk7G0VRCnOCVFyMPg20';

export const PM_RECORD_STATUS = Object.freeze({
	PENDING: 'PENDING',
	SUBMITTED: 'SUBMITTED',
});

export const SPLIT_SIZES = Object.freeze({
	ECM: 30,
	OTHER: 40,
	MIN: 7,
	EMPTY: 10,
	CREATE: 24,
	NO_ATTCH: 2,
});

export const DIALOG_CONTENT_TEXT = Object.freeze({
	RFI: 'You selected a new email, would you like to update the Subject and Question fields?',
	ISSUE: 'You selected a new email, would you like to update the Subject and Description fields?',
});

export const CMIC_STATIC_TREE_NODE_ID = Object.freeze({
	START_NODE: 'START_NODE',
	CMIC_ECM: 'ROOT_NODE',
	PROJECTS_PARENT: 'PARENT_NODE_PROJECTS_ID',
	ENTERPRISE_DOCUMENTS_PARENT: 'PARENT_NODE_ENTERPRISE_DOCUMENTS_ID',
	FAVOURITE_PARENT: 'PARENT_NODE_FAVOURITE_ID',
	RECENT_ITEMS_PARENT: 'PARENT_NODE_RECENT_ID',
});

export const CMIC_TREE_NODE_TYPES = Object.freeze({
	DEFAULT: 'default',
	PROJECTS_PARENT: 'PARENT_NODE_PROJECTS',
	ENTERPRISE_DOCUMENTS_PARENT: 'PARENT_NODE_ENTERPRISE_DOCUMENTS',
	FAVOURITE_PARENT: 'PARENT_NODE_FAVOURITE',
	RECENT_ITEMS_PARENT: 'PARENT_NODE_RECENT',
	PROJECT: 'NODE_PROJECT',
	ENTERPRISE_DOCUMENT_TYPE: 'ENTERPRISE_DOCUMENT_TYPE',
	ENTERPRISE_DOCUMENT: 'ENTERPRISE_DOCUMENT',
	ENTERPRISE_DOCUMENT_REVISION: 'ENTERPRISE_DOCUMENT_REVISION',

	PROJECT_FOLDER_RFI: 'RFI',
	PROJECT_FOLDER_ISSUE: 'ISSUE',
	PROJECT_FOLDER_COMMUNICATION: 'COMM',
	PROJECT_FOLDER_SUBMITTALS: 'SBMT',
	PROJECT_FOLDER_DAILY_JOURNAL: 'PMDAYJR',
	PROJECT_FOLDER_DOCUMENTS: 'DOC',
	PROJECT_FOLDER_SUBCONTRACTORS: 'SCMAST',
	PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS: 'PMSCCO',
	PROJECT_FOLDER_PCI: 'PMCHGM',
	PROJECT_DOCUMENT: 'PROJECT_DOCUMENT',
	PROJECT_DOCUMENT_REVISION: 'PROJECT_DOCUMENT_REVISION',

	PROJECT_RFI: 'PROJECT_RFI',
	PROJECT_ISSUE: 'PROJECT_ISSUE',
	PROJECT_COMMUNICATION: 'PROJECT_COMMUNICATION',
	PROJECT_SUBMITTALS: 'PROJECT_SUBMITTALS',
	PROJECT_DAILY_JOURNAL: 'PROJECT_DAILY_JOURNAL',
	PROJECT_DOCUMENTS: 'PROJECT_DOCUMENTS',
	PROJECT_DOCUMENT_TYPE: 'PROJECT_DOCUMENT_TYPE',
	PROJECT_DOCUMENT_TYPE_REVISION: 'PROJECT_DOCUMENT_TYPE_REVISION',
	PROJECT_SUBCONTRACTORS: 'PROJECT_SUBCONTRACTORS',
	PROJECT_SUBCONTRACTORS_CHANGE_ORDERS: 'PROJECT_SUBCONTRACTORS_CHANGE_ORDERS',
	PROJECT_PCI: 'PROJECT_PCI',
});

export const CMIC_OBJECT_CODES = Object.freeze({
	SC_OBJECT_CODE: 'SCMAST',
	SCCO_OBJECT_CODE: 'SCMAST',
	RFI_OBJECT_CODE: 'PMRFI',
	COMMUNICATION_OBJECT_CODE: 'PMCMN',
	ISSUE_OBJECT_CODE: 'DMISSUE',
	SUBMITTALS_OBJECT_CODE: 'PMSBM',
	DAILY_JOURNAL_OBJECT_CODE: 'PMDAYJR',
	PCI_OBJECT_CODE: 'PMCHGM',
	CMM_OBJECT_CODE: 'CMMAST', // Used for double click feature
	ECMDOC: 'DOC', // Used in double click feature
});

export const CMIC_MS_PLUGIN_NAMES = Object.freeze({
	GET_WEB_SERVICE_FLAGS: 'getWebServiceFlags',
	GET_PROJECTS: 'getProjects',
	GET_PROJECT_INFO: 'getProjectInfo',
	GET_ENTERPRISE_DOCUMENTS: 'getDocumentTypes',
	GET_ENTERPRISE_DOC_FOR_DOC_TYPE: 'getDocumentsForDocumentType',
	GET_ENTERPRISE_REVISIONS_FOR_DOC: 'getRevisionsForDocument',
	GET_PROJECT_FILTER_FOLDERS: 'getProjectFilterFolders',
	GET_ECM_RFI: 'getEcmRfis',
	GET_ECM_ISSUE: 'getEcmIssues',
	GET_ECM_COMMUNICATION: 'getEcmCommunication',
	GET_ECM_SUBMITTALS: 'getEcmSubmittals',
	GET_ECM_DAILY_JOURNAL: 'getDailyJournal',
	GET_ECM_DOCUMENTS: 'getEcmDocTypes',
	GET_ECM_SUBCONTRACTORS: 'getSubContractors',
	GET_ECM_SUBCONTRACTORS_CHANGE_ORDERS: 'getSubContractorsChorders',
	GET_ECM_PCI: 'getEcmPci',
	GET_ECM_DOC_METADATA: 'getecmdocsmetadata',
	GET_ECM_DOC_REVISION_METADATA: 'getEcmRevisions',
	GET_ECM_ATTACHMENTS: 'getEcmAttachments',
	DOWNLOAD_ECM_DOCUMENT: 'downloadecmdocument',
	GET_PM_COM_DETAIL: 'getPmcomDetail',
	GET_PM_ISSUE_DETAIL: 'getPmIssueDetail',
	GET_PM_RFI_DETAIL: 'getPmRFIDetail',
	GET_PM_SBM_DETAIL: 'getPmSbmDetail',
	GET_RESPONSIBILITY_LOV_ISSUE: 'getResponsibilityLovIssue',
	GET_MANDATORY_FIELDS_FOR_ISSUE: 'getMandatoryFieldsforIssue',
	RFI_MANDATORY_FIELDS: 'rfiMandatoryFields',
	GET_OBJECT_CONFIG_DOC_TYPE: 'getObjectConfigDocType',
	CREATE_SENDER_ONLY_RFI: 'createSenderOnlyRfi',
	CREATE_ONLY_ISSUE: 'createOnlyIssue',
	CREATE_ONLY_COMMUNICATION: 'createOnlyCommunication',
	CREATE_ASYNC_ATTACHMENT: 'createAsyncAttachment',
	CREATE_ONLY_RFI_V2: 'createOnlyRfiV2',
	CREATE_URL: 'createURL',
});

export const CMIC_PM_REST_NAMES = Object.freeze({
	FILED_REST_API: '/cmic-field-rest-api',
	CMIC_ECM_REST_API: '/cmic-ecm-rest-api',
});

export const CMIC_FIELD_REST__NAMES = Object.freeze({
	LOGIN: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/login`,
	LOGIN_ECM: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/jersey/v1/login`,
	LOGOUT: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/logout`,
	docTypesWithCount: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/rest/v1/docTypesWithCount`,
	ImgSources: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/rest/v1/ImgSources`,
	getProjectFilterFolders: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/jersey/v8/getProjectFilterFolders`,
	userRoles: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/user-roles`,
	documents: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v2/documents`,
	PMMEDIA: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/object-document-type-settings/PMMEDIA`,
	apps_root_uri: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/apps-root-uri`,
	revisions: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/revisions`,
	getRevisionsForDocument: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/rest/v1/getRevisionsForDocument`,
	getDocumentsForDocumentType: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/rest/v1/getDocumentsForDocumentType`,
	projects: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/projects`,
	rfisv12: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/rfisv12`,
	issues: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/issues`,
	journals: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/journals`,
	submittals: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/submittals`,
	pcis: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/pci`,
	contacts: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/contacts`,
	rfistatus: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/rfistatus`,
	issuestatus: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/issuestatus`,
	issuepriority: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/issuepriority`,
	issuetype: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/issuetype`,
	locationcode: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/locationcode`,
	documenttypes: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/documenttypes`,
	doc_for_documenttypes: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/documents`,
	customfieldsdefinition: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/customfieldsdefinition`,
	cflovs: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/cflovs`,
	documentstatus: `${CMIC_PM_REST_NAMES.FILED_REST_API}/rest/1/documentstatus`,
	fieldRestApiInfo: `${CMIC_PM_REST_NAMES.FILED_REST_API}/jersey/v1/api-info`,
	ecmRestApiInfo: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/jersey/v1/api-info`,
	uploadDocument: `${CMIC_PM_REST_NAMES.CMIC_ECM_REST_API}/jersey/v1/documents`,
});

export const CMIC_PM_OBJECTS_TYPES = Object.freeze({
	PM_TYPE_COMMUNICATION: 'PMCMN',
	PM_TYPE_DAILY_JOURNAL: 'PMDAYJR',
	PM_TYPE_ISSUE: 'DMISSUE',
	PM_TYPE_PCI: 'PMCHGM',
	PM_TYPE_RFI: 'PMRFI',
	PM_TYPE_SUBCONTRACT: 'SCMAST',
	PM_TYPE_SUBCONTRACTS_CHANGE_ORDER: 'SCMAST',
	PM_TYPE_SUBMITTAL: 'PMSBM',
});
export const CMIC_KEYS = Object.freeze({
	SERVER_SETTINGS_ENCRYPTION_KEY: 'CMiC@TRIPLEDESENCRYPTION',
	SERVER_SETTINGS_ENCRYPTION_VECTOR: 'CMiCDMIV',
	SELCTED_PROJ_ENCRYPTION_KEY: 'SELCTED_PROJ_ENCRYPTION_KEY',
	SELCTED_IMAGING_DOC_ENCRYPTION_KEY: 'SELCTED_IMAGING_DOC_ENCRYPTION_KEY',
	PROJECT_LIST_ENCRYPTION_KEY: 'PROJECT_LIST_ENCRYPTION_KEY',
});

export const USER_ROLE_TYPE = Object.freeze({
	CREATE: 'create-document-',
	LINK: 'link-document-',
	UNLINK: 'unlink-document-',
	DELETE: 'delete-document-',
	UPDATE: 'update-document-',
	VIEW: 'view-document-',
	SHOW: 'showinmenu-documenttype-',
});

export const CHILD_DEFAULT_NODES = [
	{
		name: 'Enterprise Documents',
		nodeId: CMIC_STATIC_TREE_NODE_ID.ENTERPRISE_DOCUMENTS_PARENT,
		ecmParentNodeType: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT,
		hierarchyNodesArr: [
			{
				nodeName: 'Enterprise Documents',
				nodeId: CMIC_STATIC_TREE_NODE_ID.ENTERPRISE_DOCUMENTS_PARENT,
			},
		],
	},
	{
		name: 'Projects',
		nodeId: CMIC_STATIC_TREE_NODE_ID.PROJECTS_PARENT,
		ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECTS_PARENT,
		hierarchyNodesArr: [{ nodeName: 'Projects', nodeId: CMIC_STATIC_TREE_NODE_ID.PROJECTS_PARENT }],
	},
	// { name: "Favorites", id: APP_CONSTANTS.CMIC_STATIC_TREE_NODE_ID.FAVOURITE_PARENT, objServerSettings: userInfo },
	// {
	//   name: "Recent Items",
	//   id: APP_CONSTANTS.CMIC_STATIC_TREE_NODE_ID.RECENT_ITEMS_PARENT,
	//   objServerSettings: userInfo,
	// },
];

export const TYPE_OF_DOCUMENT = Object.freeze({
	png: 'image/png',
	pdf: 'application/pdf',
	txt: 'text/plain',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	htm: 'text/htm',
	html: 'text/html',
	doc: 'application/msword',
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	xls: 'application/vnd.ms-excel',
	jpg: 'image/jpg',
	jpeg: 'image/jpeg',
	bmp: 'image/bmp',
	pptx: 'applicatiapplication/vnd.openxmlformats-officedocument.presentationml.presentation',
	ppt: 'application/vnd.ms-powerpoint',
	tiff: 'image/tiff',
	xml: 'text/html',
	wmv: 'video/x-ms-wmv',
	wma: 'audio/x-ms-wma',
	eml: 'eml',
});

export const FILE_TYPE = {
	Image: 'Image',
	Video: 'Video',
	Pdf: 'Pdf',
	Text: 'Text',
	Email: 'Email',
	JSON: 'JSON',
	Zip: 'Zip',
	Excel: 'Excel',
	Audio: 'Audio',
	Word: 'Word',
	Xml: 'Xml',
	Other: 'Other',
};

export const ICON_NAMES = {
	FOLDER: 'FabricFolderFill',
	FILE: 'FileComment',
	FILE_REVERSE: 'FileSymlink',
};

export const ATTACHMENT_ACTION_ICONS = {
	proj: { iconName: 'FabricFolderFill', label: 'Documents', type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS },
	ecm: {
		iconName: 'FabricFolderFill',
		label: 'Home',
		type: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT,
	},
};

export const NEW_ACTION_ICONS = [
	{
		iconName: 'info',
		label: 'RFI',
		type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI,
		isDisabled: false,
		isDefaultIcon: false,
	},
	{
		iconName: 'warning',
		label: 'Issue',
		type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE,
		isDisabled: false,
		isDefaultIcon: false,
	},
	// {
	//   iconName: "OfficeChatSolid",
	//   label: "Communication",
	//   type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION,
	//   isDisabled: true,
	// },
];

export const EXISTING_ACTION_ICONS = [
	[
		{
			iconName: 'info',
			label: 'RFI',
			type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI,
			isDisabled: false,
			isDefaultIcon: false,
		},
		{
			iconName: 'warning',
			label: 'Issue',
			type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE,
			isDisabled: false,
			isDefaultIcon: false,
		},
	],
	[
		{
			iconName: 'description',
			label: 'Submittal',
			type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS,
			isDisabled: false,
			isDefaultIcon: false,
		},
		{
			iconName: 'note_alt',
			label: 'Journals',
			type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL,
			isDisabled: false,
			isDefaultIcon: false,
		},
	],
	// [{ iconName: "TriangleUp12", label: "PCI", type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_PCI, isDisabled: false }], // TODO PCI Button
	// [

	//   { iconName: "InfoSolid", label: "RFI", type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI, isDisabled: false },
	//   {
	//     iconName: "IncidentTriangle",
	//     label: "Issue",
	//     type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE,
	//     isDisabled: false,
	//   },
	//   {
	//     iconName: "ReadingModeSolid",
	//     label: "Submittal",
	//     type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS,
	//     isDisabled: false,
	//   },
	//   {
	//     iconName: "PageListSolid",
	//     label: "Daily Journal",
	//     type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL,
	//     isDisabled: false,
	//   },
	// ],
	// [
	// {
	//   iconName: "ShowTimeAs",
	//   label: "Subcontract",
	//   type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS,
	//   isDisabled: true,
	// },
	// {
	//   // iconName: "ConstructionConeSolid",
	//   iconName: "IssueSolid",
	//   label: "Change Order",
	//   type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS,
	//   isDisabled: true,
	// },
	// {
	//   iconName: "OfficeChatSolid",
	//   label: "Communication",
	//   type: CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION,
	//   isDisabled: true,
	// },
	//  ]
];

export const ACTION_TYPE = Object.freeze({
	ATTACHMENT: 'ATTACHMENT',
	NEW: 'NEW',
	EXISTING: 'EXISTING',
	IMAGING: 'IMAGING',
});

export const ACTION_ROLE = Object.freeze({
	PROJECT: 'PROJECT',
	ECM: 'ECM',
});

export const OFFICE_POPUP = Object.freeze({
	WINDOWPOPUP: 'WINDOWPOPUP',
	OFFICE_DIALOG: 'OFFICE_DIALOG',
	MSALPOPUP: 'MSALPOPUP',
});

export const APP_NAME = 'CMiC for Outlook';

export const NODE_TYPE = Object.freeze({
	DMDOC: 'IMAGES',
	ECMDOC: 'DOC',
	PMItem: 'PMItem',
	Attachment: 'Attachment',
	Other: 'Journal/PCI/Other',
});

export const CMIC_LOCAL_ENV = {
	label: 'cmic outlook -dev',
	url: 'https://mob6dmz.cmicglobal.com/cmicdevv12',
};

export const CMIC_TEST_ENV_CLOUD = [
	{
		label: 'ATLAS TEST',
		url: 'https://atlas-api-test-oauth.cmiccloud.com/cmictest',
	},
	{
		label: 'NOVA TEST',
		url: 'https://nova-api-test-oauth.cmiccloud.com/cmictest',
	},
];

export const CMIC_PROD_ENV_CLOUD = [
	{
		label: 'ATLAS PROD',
		url: 'https://atlas-api-oauth.cmiccloud.com/cmicprod',
	},
	{
		label: 'NOVA PROD',
		url: 'https://nova-api-oauth.cmiccloud.com/cmicprod',
	},
];

export const INIT_TOAST_CONFIG = {
	isVisible: false,
	type: null,
	msg: '',
	isPersistent: false,
};
